export default "__VITE_ASSET__BD2cXB0T__"